import React from 'react';
import { TLevelistOption } from '../../../api/endpoints/SubsetOption';
import Checkbox from '../../Inputs/Checkbox/Checkbox';
import CheckboxWrap from '../../Ui/CheckboxWrap';
import SelectAllControl from "../SelectAllControl";

const LevelistSelector = (props: {
  values: Array<string>;
  spec: TLevelistOption;
  onChange: (values: Array<string>) => void;
}) => {
  const { values, spec, onChange } = props;
  const options = spec.value.levelist;
  const checkedValues = new Set<string>(values);

  const onCheckboxChange = (value: string, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  };

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <CheckboxWrap>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={option}
              value={option}
              checked={checkedValues.has(option)}
              name="levelist"
              onChange={(checked) => onCheckboxChange(option, checked)}
            />)
        }
      </CheckboxWrap>
    </div>
  );
};

export default LevelistSelector;
